import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { CardExpiryElement, useElements } from '@stripe/react-stripe-js';
import * as S from '../stripe-inputs.style';
import { useTranslation } from 'react-i18next';
import type { StripeElementRef } from '../stripe-card-input/stripe-card-input';

type Props = {
  containerId?: string;
  elementId?: string;
  onStripeChange?: (
    field: 'number' | 'expiry' | 'cvc',
    state: { complete: boolean; error: string | null },
  ) => void;
  variant?: 'classic' | 'modern';
  color?: string;
};

export const StripeExpiryInput = forwardRef<StripeElementRef, Props>(
  (
    {
      containerId = 'stripe-expiry-container',
      elementId = 'stripe-expiry',
      onStripeChange,
      variant = 'classic',
      color,
    },
    ref,
  ) => {
    const { t } = useTranslation();
    const [isFocused, setIsFocused] = useState(false);
    const elements = useElements();

    useImperativeHandle(ref, () => ({
      focus() {
        const el = elements?.getElement(CardExpiryElement);
        el?.focus();
      },
    }));

    return (
      <S.Content id={containerId}>
        <S.InputWrapper>
          <S.StyledStripeElement
            color={color}
            $focused={isFocused}
            $variant={variant}
          >
            <CardExpiryElement
              id={elementId}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              onChange={(e) =>
                onStripeChange?.('expiry', {
                  complete: e.complete,
                  error: e.error?.code ?? null,
                })
              }
              options={{
                placeholder: t('expiryFormat'),
                style: {
                  base: {
                    '::placeholder': {
                      color: '#9ca3af',
                    },
                  },
                  invalid: {
                    color: '#000',
                  },
                },
              }}
            />
          </S.StyledStripeElement>
        </S.InputWrapper>
      </S.Content>
    );
  },
);
